(() => {
  const campaignMarker = 'PROEARLY15';

  const initialize = (root = document) => {
    const sections = [];
    if (root.matches && root.matches('[data-pro-earlybird-root]')) sections.push(root);
    if (root.querySelectorAll) sections.push(...root.querySelectorAll('[data-pro-earlybird-root]'));

    sections.forEach((section) => {
      if (section.dataset.proEarlybirdInitialized === 'true') return;
      section.dataset.proEarlybirdInitialized = 'true';

      const offer = section.querySelector('[data-pro-earlybird]');
      const regularPrice = section.querySelector('[data-pro-regular-price]');
      const button = section.querySelector('[data-pro-earlybird-button]');
      if (!offer || !button) return;

      const cutoff = Number(offer.dataset.proEarlybirdCutoff || 0);
      const markerMatches = new URLSearchParams(window.location.search).get('utm_id') === campaignMarker;
      const offerIsActive = markerMatches && (!cutoff || Math.floor(Date.now() / 1000) < cutoff);

      section.dataset.proEarlybirdActive = offerIsActive ? 'true' : 'false';
      offer.hidden = !offerIsActive;
      if (regularPrice) regularPrice.hidden = offerIsActive;
      button.querySelectorAll('[data-pro-earlybird-label]').forEach((label) => {
        label.hidden = !offerIsActive;
      });
      button.querySelectorAll('[data-pro-regular-label]').forEach((label) => {
        label.hidden = offerIsActive;
      });
      section.dispatchEvent(new CustomEvent('pro:earlybird-change', {
        bubbles: true,
        detail: { active: offerIsActive },
      }));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
